export default "__VITE_ASSET__cl1JlZ5T__"